<template>
    <div class="status-wrapper">
        <PtIcon v-if="count > 0.6" icon="SolidDataHighCoverage"/>
        <PtIcon v-else-if="count > 0" icon="SolidDataLowCoverage"/>
        <span v-else class="empty">-</span>
    </div>
</template>

<script>
import { Icon as PtIcon } from 'patsnap-biz';
import '@patsnap-ui/icon/assets/solid/DataLowCoverage.svg';
import '@patsnap-ui/icon/assets/solid/DataHighCoverage.svg';

export default {
    name: 'Status',
    components: {
        PtIcon
    },
    props: {
        count: {
            type: Number,
            isRequired: true,
        }
    }
};
</script>

<style lang="scss">
.status-wrapper {
    .patsnap-biz-icon {
        fill: $green-primary !important;
        font-size: 24px;
    }

    .empty {
        margin-left: 6px;
    }
}
</style>
